const API_BASE = "";

async function apiRequest(path, { method = "GET", body, headers = {}, isForm = false } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    credentials: "include",
    headers: {
      ...(isForm ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
    body: body == null ? undefined : isForm ? body : JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || "Request failed");
    error.status = res.status;
    error.data = data;
    throw error;
  }
  return data;
}

export const api = {
  health: () => apiRequest("/api/health"),

  getPublicBlogs: () => apiRequest("/api/public/blogs"),
  getPublicBlogBySlug: (slug) => apiRequest(`/api/public/blogs/${encodeURIComponent(slug)}`),
  getPublicLinks: () => apiRequest("/api/public/links"),
  createSubmission: (payload) => apiRequest("/api/public/submissions", { method: "POST", body: payload }),

  authLoginStart: (payload) => apiRequest("/api/auth/login/start", { method: "POST", body: payload }),
  authLoginVerifyCode: (payload) => apiRequest("/api/auth/login/verify-code", { method: "POST", body: payload }),
  authRecoveryStart: (payload) => apiRequest("/api/auth/recovery/start", { method: "POST", body: payload }),
  authRecoveryVerifyCode: (payload) => apiRequest("/api/auth/recovery/verify-code", { method: "POST", body: payload }),
  authRecoveryResetPassword: (payload) => apiRequest("/api/auth/recovery/reset-password", { method: "POST", body: payload }),
  authMe: () => apiRequest("/api/auth/me"),
  authLogout: () => apiRequest("/api/auth/logout", { method: "POST" }),

  getSubmissions: () => apiRequest("/api/admin/submissions"),
  getArchivedSubmissions: () => apiRequest("/api/admin/submissions?archived=true"),
  // Reading a single submission is what the server records in the audit log,
  // so the detail view must go through here rather than reuse the list payload.
  getSubmissionById: (id) => apiRequest(`/api/admin/submissions/${id}`),
  archiveSubmission: (id) => apiRequest(`/api/admin/submissions/${id}/archive`, { method: "POST" }),
  unarchiveSubmission: (id) => apiRequest(`/api/admin/submissions/${id}/unarchive`, { method: "POST" }),

  getAdminBlogs: () => apiRequest("/api/admin/blogs"),
  createBlog: (payload) => apiRequest("/api/admin/blogs", { method: "POST", body: payload }),
  updateBlog: (id, payload) => apiRequest(`/api/admin/blogs/${id}`, { method: "PATCH", body: payload }),
  deleteBlog: (id) => apiRequest(`/api/admin/blogs/${id}`, { method: "DELETE" }),

  getAdminLinks: () => apiRequest("/api/admin/links"),
  createLink: (payload) => apiRequest("/api/admin/links", { method: "POST", body: payload }),
  updateLink: (id, payload) => apiRequest(`/api/admin/links/${id}`, { method: "PATCH", body: payload }),
  deleteLink: (id) => apiRequest(`/api/admin/links/${id}`, { method: "DELETE" }),

  uploadMedia: (file) => {
    const body = new FormData();
    body.append("file", file);
    return apiRequest("/api/admin/media", { method: "POST", body, isForm: true });
  },

  getAdmins: () => apiRequest("/api/admin/admins"),
  createAdmin: (payload) => apiRequest("/api/admin/admins", { method: "POST", body: payload }),
  updateAdmin: (id, payload) => apiRequest(`/api/admin/admins/${id}`, { method: "PATCH", body: payload }),
  deleteAdmin: (id) => apiRequest(`/api/admin/admins/${id}`, { method: "DELETE" }),
  updateMyEmail: (email) => apiRequest("/api/admin/admins/me/email", { method: "PATCH", body: { email } }),
  getAuditLogs: (page = 1) => apiRequest(`/api/admin/audit-logs?page=${page}`),
};
